var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m820 1587.5c0-8.8375 7.1625-16 16-16s16 7.1625 16 16-7.1625 16-16 16-16-7.1625-16-16zm23.237499-2.7625c.681252-.68125.681252-1.79375 0-2.475-.681249-.68125-1.793749-.68125-2.474998 0l-6.762501 6.7625-2.7625-2.7625c-.68125-.68125-1.79375-.68125-2.475 0s-.68125 1.79375 0 2.475l4 4c.68125.68125 1.79375.68125 2.475 0z","fill":"#3b529f","transform":"translate(-820 -1571)"}));
}

CheckCircle.defaultProps = {"height":"33","viewBox":"0 0 32 33","width":"32"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
